import { isMobile } from "./device"

export const refererAnchorElements = () => document.querySelectorAll<HTMLAnchorElement>("a[data-referer]")

export function updateRefererLinks() {
    for (const element of Array.from(refererAnchorElements())) {
        const url = new URL(element.getAttribute("href") || "", window.location.origin)
        const path = window.location.pathname.substring(1) + window.location.search + element.dataset.referer
        url.searchParams.set("ref", path === "" ? "/" : path)
        element.setAttribute("href", url.pathname + url.search)
    }
}

export function updatePlatformLinks() {
    const selector = isMobile() ? ".desktopLink" : ".mobile-version-button"
    for (const element of Array.from(document.querySelectorAll<HTMLAnchorElement>(selector))) {
        const newUrl = new URL(window.location.href)
        const oldUrl = new URL(element.href)
        newUrl.host = oldUrl.host
        element.href = newUrl.href
    }
}

export function updateLinks() {
    updateRefererLinks()
    updatePlatformLinks()
}

updateLinks()
